<template>
    <div>
        <el-input v-model="query.fake_id" placeholder="假ID" style="width: 120px" :disabled="loading"></el-input>
        <el-input v-model="query.nickname" placeholder="内部名称" style="width: 120px" :disabled="loading"></el-input>
        <el-input v-model="query.creator" placeholder="创建人" style="width: 120px" :disabled="loading"></el-input>
        <el-input v-model="query.updater" placeholder="最后修改人" style="width: 120px" :disabled="loading"></el-input>
        <el-date-picker 
            v-model="query.c_time_range" 
            type="datetimerange" 
            range-separator="至" 
            start-placeholder="首次创建时间" 
            end-placeholder="最后创建时间" 
            style="width: 300px; margin-left: 10px"
            :disabled="loading">
        </el-date-picker>
        <el-date-picker 
            v-model="query.u_time_range" 
            type="datetimerange" 
            range-separator="至" 
            start-placeholder="首次修改时间" 
            end-placeholder="最后修改时间" 
            style="width: 300px; margin-left: 10px"
            :disabled="loading">
        </el-date-picker>
        <el-button type="success" :loading="loading" @click="init" style="margin-left: 10px">查询</el-button>
        <el-button type="primary" :loading="loading" @click="openDialog()">新建</el-button>
    </div>
    <el-table :data="data" v-loading="loading" style="margin-top: 10px">
        <el-table-column label="假ID" prop="fake_id" width="80"></el-table-column>
        <el-table-column label="内部名称" prop="nickname" width="120"></el-table-column>
        <el-table-column label="EN" prop="EN" min-width="250">
            <template #default="scope">
                <div style="white-space: pre-line;">{{ scope.row.EN }}</div>
            </template>
        </el-table-column>
        <el-table-column label="创建人" prop="creator" width="100"></el-table-column>
        <el-table-column label="最后修改人" prop="updater" width="100"></el-table-column>
        <el-table-column label="创建时间" prop="c_time" width="150">
            <template #default="scope">
                {{ timestampToDate(scope.row.c_time) }}
            </template>
        </el-table-column>
        <el-table-column label="最后修改时间" prop="u_time" width="150">
            <template #default="scope">
                {{ timestampToDate(scope.row.u_time) }}
            </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
            <template #default="scope">
                <el-button size="small" :disabled="loading" @click="openDialog(scope.row)">编辑</el-button>
                <el-button size="small" type="danger" :disabled="loading" @click="deleteRow(scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-pagination layout="prev, pager, next" :total="total" @current-change="fetchData"
        :page-size="query.limit"></el-pagination>
    <el-dialog v-model="dialog_opened" :before-close="reset">
        <el-form :model="form" ref="form" label-width="100px">
            <el-form-item label="内部名称" prop="nickname" :rules="[{ required: true, message: '请设定内部名称' }]">
                <el-input v-model="form.nickname" :disabled="loading"></el-input>
            </el-form-item>
            <el-form-item label="EN" prop="EN" :rules="[{ required: true, message: '请输入EN' }]">
                <el-input v-model="form.EN" type="textarea" :rows="4" :disabled="loading"></el-input>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button type="primary" text :loading="loading" @click="reset">取消</el-button>
            <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
        </template>
    </el-dialog>
</template>

<script>
import axios from "ts-axios-new";
import { update, timestampToDate } from "../libs/utils";
import { ElMessageBox, ElMessage } from "element-plus";

export default {
    name: "Copywriting",
    data() {
        return {
            loading: false, 
            data: [], 
            editing: null, 
            total: 0, 
            dialog_opened: false,
            query: {
                fake_id: null,
                nickname: null,
                creator: null,
                updater: null,
                c_time_range: null,
                u_time_range: null,
                skip: 0,
                limit: 100,
            },
            form: {
                nickname: '',
                EN: '',
                username: this.$root.user.name,
            },
        }
    },
    methods: {
        timestampToDate(timestamp) {
            return timestampToDate(timestamp);
        },
        init() {
            this.fetchData(1)
        },
        fetchData(page) {
            this.query.skip = page - 1;
            this.loading = true;
            
            // 处理时间范围参数
            const params = { ...this.query };
            if (params.c_time_range && params.c_time_range.length === 2) {
                params.c_time_start = params.c_time_range[0].getTime() / 1000;
                params.c_time_end = params.c_time_range[1].getTime() / 1000;
                delete params.c_time_range;
            }
            if (params.u_time_range && params.u_time_range.length === 2) {
                params.u_time_start = params.u_time_range[0].getTime() / 1000;
                params.u_time_end = params.u_time_range[1].getTime() / 1000;
                delete params.u_time_range;
            }
            
            axios.get(`/cms/v1/copywriting`, { params }).then(res => {
                this.data = res.data.data.list;
                this.total = res.data.data.total;
                this.loading = false;
            }).catch(err => {
                this.loading = false;
                ElMessage.error('获取文案失败，请稍后重试');
                console.error(err);
            });
        },
        openDialog(item) {
            this.dialog_opened = true;
            this.$nextTick(_ => {
                this.editing = item;
                if (item) {
                    update(this.form, item);
                } else {
                    this.form.nickname = '';
                    this.form.EN = '';
                }
            });
        },
        reset() {
            this.$refs.form.resetFields();
            this.dialog_opened = this.loading = false;
            this.editing = null;
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading = true;
                    if (this.editing) {
                        axios.patch(`/cms/v1/copywriting/${this.editing.id}`, this.form).then(res => {
                            update(this.editing, res.data.data);
                            this.reset();
                            ElMessage.success('更新成功');
                        }).catch(err => {
                            this.loading = false;
                            ElMessage.error('更新失败，请稍后重试');
                            console.error(err);
                        });
                    } else {
                        axios.post(`/cms/v1/copywriting`, this.form).then(res => {
                            this.data.unshift(res.data.data);
                            this.reset();
                            ElMessage.success('创建成功');
                        }).catch(err => {
                            this.loading = false;
                            ElMessage.error('创建失败，请稍后重试');
                            console.error(err);
                        });
                    }
                }
            });
        },
        deleteRow(row) {
            ElMessageBox.confirm(`确定删除该项吗？`, '提示', {
                type: 'warning',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(_ => {
                this.loading = true;
                axios.delete(`/cms/v1/copywriting/${row.id}`).then(_ => {
                    this.data.splice(this.data.indexOf(row), 1);
                    this.loading = false;
                    ElMessage.success('删除成功');
                }).catch(err => {
                    this.loading = false;
                    ElMessage.error('删除失败，请稍后重试');
                    console.error(err);
                });
            }).catch(_ => {
            });
        },
        updateRow(row) {
            this.loading = true;
            axios.patch(`/cms/v1/copywriting/${row.id}`, row).then(_ => {
                this.loading = false;
                ElMessage.success('更新成功');
            }).catch(err => {
                this.loading = false;
                ElMessage.error('更新失败');
            });
        },
    },
    mounted() {
        this.init();
    }
}
</script>

<style scoped></style>